export default "__VITE_ASSET__CksBT4Kt__"